import Image from 'next/image'
import { useState } from 'react'
import useUser from '../../../lib/useUser'
import Button from '../Button'
import BaseModal from './BaseModal'
import { useTranslation } from '../../../lib/i18n'

function OnboardingModal({ user }) {
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState(user.onboarded_at == null)
  const { updateUser } = useUser()

  const onClose = async () => {
    const body = { ...user, onboarded_at: new Date().toISOString() }
    setShowModal(false)
    try {
      await updateUser(body)
    } catch (error) {
      console.error('An unexpected error happened:', error)
    }
  }

  return (
    <BaseModal closeIcon isOpen={showModal} onRequestClose={() => onClose()}>
      <div className="w-full">
        <div className="bg-white rounded-lg p-4 mb-4">
          <div className="flex flex-row gap-2">
            <Image
              key={t('onboarding.founder.name')}
              src="/andrew.png"
              alt={`${t('onboarding.founder.name')} avatar`}
              width={30}
              height={30}
              priority
              className="rounded-full w-16 h-16"
            />
            <div className="flex flex-col">
              <p className="text-sm text-gray-600 my-1">
                {t('onboarding.founder.intro')}
              </p>
              <p className="text-sm text-gray-600 my-1">
                {t('onboarding.founder.cta')}
              </p>
            </div>
          </div>
        </div>
        <div>
          <Button
            primary
            className="mt-6"
            type="submit"
            onClick={() => onClose()}
          >
            Continue
          </Button>
        </div>
      </div>
    </BaseModal>
  )
}

export default OnboardingModal
